function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Errors, UserGroup, Action, Label } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // グループモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          GroupName: "",
          ErrorMessages: []
        };
        break;

      case Mode.Modify:
        _this.state = {
          Modal: null,
          GroupName: _this.props.groupName,
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    return _this;
  }
  /**
   * グループ名を更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateGroupName",
    value: function updateGroupName(e) {
      this.setState({
        GroupName: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.props.onEntry(this.state.GroupName, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        if (!this.props.groupId) {
          throw Error();
        }

        this.props.onModify(this.props.groupId, this.state.GroupName, this.props.organizationId, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDelete",
    value: function onDelete() {
      if (this.state.Modal == null || !this.props.groupId) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;
      this.props.onDelete(this.props.groupId, this.props.updateDateTime);
      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#UserGroupModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "UserGroupModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "42",
        src: "/assets/img/usergroup_icon.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(UserGroup.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "GroupName"
      }, intl.format(Label.Group)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "GroupName",
        id: "GroupName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this3.updateGroupName(e);
        },
        value: this.state.GroupName,
        tabIndex: 101
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "GroupName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry)), this.props.mode == Mode.Modify && [/*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), /*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDelete.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))]))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };